import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: '[dialogActions]',
})
export class DialogActionsDirective {
    constructor(public tpl: TemplateRef<any>) { }
}